import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

import './TextInput.scss';

interface Props {
  placeholder?: string
  type?: string
  label: string
  defaultValue?: string
  require?: boolean
  error?: string | undefined
  disable?: boolean,
  useFormRegisterReturn: UseFormRegisterReturn
  hint?: string
}

const Input = ({
  placeholder,
  type = 'text',
  label,
  error,
  disable,
  useFormRegisterReturn,
  hint,
}: Props): React.ReactElement => {
  const classNames = ['text-input', error ? 'has-error' : undefined];
  const inputName = useFormRegisterReturn.name;

  return (
    <div className={classNames.join(' ')}>
      <label htmlFor={inputName} className="label">
        <span>
          {label}
        </span>

        <input
          /**
           * https://react-hook-form.com/migrate-v6-to-v7/
           * register method is no longer occurred at ref, instead invoke the function itself
           * and spread the props into the input. The function itself will return the following
           * props: onChange, onBlur, name and ref.
           */
          // eslint-disable-next-line
          {... useFormRegisterReturn}
          className="input"
          placeholder={placeholder}
          type={type}
          id={inputName}
          disabled={disable}
        />
      </label>

      {hint && (
        <div className="form-field-hint">
          {hint}
        </div>
      )}

      {error && (
        <div className="form-field-error">
          {error}
        </div>
      )}
    </div>
  );
};

export default Input;
